import apiClient from './apiClient';

// Use the main apiClient which has proper error handling
const api = apiClient;

export const payslipsApi = {
  // Get payslip batches (legacy - for backward compatibility)
  getPayslipBatches: async () => {
    try {
      const response = await api.get('/payroll/payslips/batches');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get payslip batch list (new endpoint)
  getPayslipBatchList: async (params = {}) => {
    try {
      const response = await api.get('/payroll/payslips/batch/list', { params });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Create a new payslip batch
  createPayslipBatch: async (batchData) => {
    try {
      const response = await api.post('/payroll/payslips/batch/create', batchData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Generate payslips for a batch
  generatePayslipsForBatch: async (batchId, sendEmails = false) => {
    try {
      
      const response = await api.post(`/payroll/payslips/batch/${batchId}/generate`, {
        sendEmails
      });
      
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Get payslips by batch (payrollRunId) - legacy
  getPayslipsByBatch: async (payrollRunId) => {
    try {
      
      const response = await api.get(`/payroll/payslips/batch/${payrollRunId}`);
      
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Get detailed payslips for a batch with pagination (new endpoint)
  getPayslipBatchDetails: async (batchId, page = 1, limit = 20, search = '') => {
    try {
      
      // apiClient interceptor already returns response.data, so response is the full response object
      const response = await api.get(`/payroll/payslips/batch/${batchId}/details`, {
        params: { page, limit, search }
      });
      
      // Return the full response object (responseCode, responseMessage, data)
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Get all payslips with filters
  getPayslips: async (params = {}) => {
    try {
      
      const response = await api.get('/payroll/payslips/enhanced', { params });
      
      // Return the full response object (responseCode, responseMessage, data)
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Get payslip by ID
  getPayslipById: async (id) => {
    try {
      const response = await api.get(`/payroll/payslips/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Generate payslips
  generatePayslips: async (payslipData) => {
    try {
      
      // apiClient interceptor already returns response.data, so response is the full response object
      const response = await api.post('/payroll/generate-payslips', payslipData);
      
      // Return the full response object (responseCode, responseMessage, data)
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Download payslip
  downloadPayslip: async (id) => {
    try {
      
      const response = await api.get(`/payroll/payslips/${id}/download`, {
        responseType: 'blob'
      });
      
      // For blob responses, the interceptor returns the blob directly
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Send payslip email
  sendPayslipEmail: async (id) => {
    try {
      
      const response = await api.post(`/payroll/payslips/${id}/send-email`);
      
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },


  // Delete payslip
  deletePayslip: async (id) => {
    try {
      
      const response = await api.delete(`/payroll/payslips/${id}`);
      
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Bulk actions
  bulkAction: async (payslipIds, action) => {
    try {
      
      const response = await api.post('/payroll/payslips/bulk-action', {
        payslipIds,
        action
      });
      
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Get employees for payslip generation
  getEmployees: async () => {
    try {
      
      const response = await api.get('/payroll/employees');
      
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Send payslip emails to all employees in a batch
  sendBatchEmails: async (batchId) => {
    try {
      
      const response = await api.post(`/payroll/payslips/batch/${batchId}/send-emails`);
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Delete payslip batch
  deletePayslipBatch: async (batchId) => {
    try {
      
      const response = await api.delete(`/payroll/payslips/batch/${batchId}`);
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Poll the progress of a bulk email send job for a given batch
  getEmailJobStatus: async (batchId) => {
    try {
      const response = await api.get(`/payroll/payslips/batch/${batchId}/email-job-status`);
      return response;
    } catch (error) {
      
      throw error;
    }
  }
};

export default payslipsApi;

